import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";

// style
import "./QRTurno.css";

import { Button } from "react-bootstrap";

import { faPrint } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function QRTurno() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  useEffect(() => {
    console.log(register);
    //Remove api https://chart.googleapis.com/chart?chs=150x150&cht=qr&chl=
    var qrText = "https://quickchart.io/qr?text=T-" + register.id + "-";
    if (register.admin) {
      qrText = qrText + register.admin.id;
    }
    var info = {
      nombre: "QR MENU",
      qr: qrText,
    };
    var qrText2 = "https://quickchart.io/qr?text=TT-" + register.id + "-";
    if (register.admin) {
      qrText2 = qrText2 + register.admin.id;
    }
    var info2 = {
      nombre: "QR TURNO",
      qr: qrText2,
    };
    var qrText3 = "https://quickchart.io/qr?text=https://onelink.to/52jvjq";
    var info3 = {
      nombre: "QR APLICACION",
      qr: qrText3,
    };
    setData([info, info2, info3]);
  }, [register]);

  const printQR = () => {
    var content = document.getElementById("project-qr");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  return (
    <div className="container">
      <iframe
        title="ifmcontentstoprint"
        className="iframePrint"
        id="ifmcontentstoprint"
      ></iframe>
      <br />

      <h4 className="page-title">GENERADOR QR</h4>
      <br />

      <div id="project-qr" className="row">
        {data.map((n) => (
          <div className="col-6">
            <div className="center">
              <>
                <img className="qr-code" src={n.qr} alt="QR"></img>
                <div className="center">{n.nombre}</div>
              </>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="center-form" onClick={printQR}>
        <Button variant="primary" className="button" type="button">
          <FontAwesomeIcon icon={faPrint} /> IMPRIMIR
        </Button>
      </div>
    </div>
  );
}
